define('PartLookup.Hotspots.View', [
  'SCView',
  'partlookup_hotspots.tpl',
  'jQuery',
  'underscore'
], function (
  SCViewModule,
  partlookup_hotspots_tpl,
  jQuery,
  _
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function PartLookupHotspotsView (options) {
    SCView.call(this, options);
    
    this.application = options.application;
    this.template = partlookup_hotspots_tpl;
    
    this.model = options.model;
    this.model.on('change:hotspots', this.render, this);

    // this.activeHotspots = [];
  }

  PartLookupHotspotsView.prototype = Object.create(SCView.prototype);

  _.extend(PartLookupHotspotsView.prototype, {

    constructor: PartLookupHotspotsView,

    getEvents: function() {
      return {
        'mouseover .hotspot': 'handleHotSpotMouseover',
        // 'mouseout .hotspot': 'handleHotSpotMouseout',
      }
    },

    handleHotSpotMouseover: function(e) {

      // this.activeHotspots.push('data');
      var $currentHotSpot = $(e.currentTarget);
      var $tooltip = jQuery('.hotspot-tooltip');
      var position = $currentHotSpot.position();
      var hotSpotHalfSize = $currentHotSpot.width() / 2;
      var tooltipHalfSize = $tooltip.width() / 2;
      var topTarget = position.top - $tooltip.height();
      var leftTarget = (position.left - (tooltipHalfSize)) + hotSpotHalfSize;

      $tooltip.empty();

      //this.buildHotspotCell($tooltip, $currentHotSpot.data('internalid'));
      this.buildHotspotCell($tooltip, $currentHotSpot.data('partid'));
      $tooltip.css({
        'top': topTarget - 20,
        'left': leftTarget,
        'display': 'block'
      }).stop().animate({
        opacity: 1
      }, 200);

    },

    // handleHotSpotMouseout: function() {

    //   var self = this;

    //   return;

    //   this.timeout = setTimeout(function() {

    //     // remove the oldest active hotspot
    //     // self.activeHotspots.shift();

    //     if ( !self.activeHotspots.length ) {
    //       self.exitTooltip();
    //     }

    //   }, 300);
    // },
    
    // exitTooltip: function() {
    //   var $tooltip = $('.hotspot-tooltip');

    //   $tooltip.stop().animate({
    //     opacity: 0
    //   }, 200, function() {
    //     $tooltip.hide();
    //   });

    // },

    getItemData: function(partId) {
      return _.findWhere(this.model.get('hotspots'), {
        PartId: partId
      });

    },

    buildHotspotCell: function(tooltipElement, partId) {
      var item = this.getItemData(partId);
      var noImageFoundUrl = 'https://staging.appliancepartscompany.com/sca-dev-2024-1-0/img/no_image_available.jpeg?resizeid=4&resizeh=220&resizew=220';
      var itemImageUrl = item.itemimages_detail && item.itemimages_detail.urls && item.itemimages_detail.urls['0'].url || noImageFoundUrl;

      var altText = item.itemimages_detail && item.itemimages_detail.urls && item.itemimages_detail.urls['0'].altimagetext || 'This item is no longer available';
      var itemName = item.storedisplayname2 ? item.storedisplayname2 : '';

      var html = '';

      if ( !!item.urlcomponent ) {
        html += `<a href="${item.urlcomponent}" data-toggle="show-in-modal">`;
      }

      html += `
        <div class="facets-item-cell-grid part-lookup-tooltip">
          <div class="facets-item-cell-grid-image-wrapper">
            <img class="facets-item-cell-grid-image" src="${itemImageUrl}"
            alt="${altText}" itemprop="image" />
          </div>
      `;

      html += this.getItemNameHtml( item.urlcomponent, itemName );

      html += `
            <div class="facet-item-cell-grid-iteminfo">
      `;

      if ( !!item.custitem_scbrand ) {
        html += `
              <div class="brand">
                <span itemprop="brand">Brand:&nbsp;</span>
                <span itemprop="brand">${item.custitem_scbrand}</span>
              </div>
        `;
      }

      else {
        html += `
              <div>
                <span>This item is no longer available</span>
              </div>
        `;
      }

      html += `
              <div class="partnumber">
                <span itemprop="partnumber">Part #:&nbsp;</span>
                <span itemprop="partnumber">${item.Sku}</span>
              </div>
              <div class="partnumber">
                <span>Diagram Tag #:&nbsp;</span>
                <span>${item.Tag}</span>
              </div>
              <div>
                <span>${item.Description}</span>
              </div>
            </div>
      `;

      if ( !!item.onlinecustomerprice_detail && !!item.onlinecustomerprice_detail.onlinecustomerprice ) {
        html += `
            <div class="facets-item-cell-grid-price">
              <div class="product-views-price">
                <span class="product-views-price-exact" itemprop="offers">
                  <meta itemprop="priceCurrency" content="USD" />
                  <span class="product-views-price-lead" itemprop="price"
                    data-rate="${item.onlinecustomerprice_detail.onlinecustomerprice}" data-role="price-lead-formatted">
                    ${item.onlinecustomerprice_detail.onlinecustomerprice_formatted}
                  </span>
              </div>
            </div>
          </div>
        </div>
        `;
      }

      else {
        html += `
            </div>
          </div>
        </div>
        `;
      }

      if ( !!item.urlcomponent ) {
        html += `</a>`;
      }

      tooltipElement.append($(html));
      // jQuery('.part-lookup-tooltip').on('mouseover', this.keepModalOpen);
      // jQuery('.part-lookup-tooltip').on('mouseout', this.handleHotSpotMouseout);
    },

    // keepModalOpen: function() {
    //   clearTimeout(this.timeout)
    // },

    getItemNameHtml: function(itemUrl, itemName) {

      var html = '';

      if ( !itemName ) {
        return html;
      }

      html += `
          <div class="facets-item-cell-grid-details">
      `;

      if ( !!itemUrl ) {
        html += `
            <a class="facets-item-cell-grid-title" data-toggle="show-in-modal" href="${itemUrl}">
        `
      }

      html += `<span itemprop="name">${itemName}</span>`

      if ( !!itemUrl ) {
        html += `</a>`
      }

      return html;

    },

    getContext: function() {

      var hasHotspots = !!this.model.get('hotspots') && !!this.model.get('hotspots').length;
			return {
        hasHotspots: hasHotspots,
        hotspotDivs: hasHotspots ? this.model.get('hotspots') : []
			};
    }

  });

  return PartLookupHotspotsView
});


            /*

          get the image size
          for each tag:
            - convert the styles from xy to % of image
            - place the hot spots?
            - populate the inner content:
              - if it's active, then it needs a link
              - if it's out of stock, then no link
      */
